<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PROJET')">
        <slot name="section-projet">
          <section-projet ref="PROJET"
                          id="PROJET"
                          :extended="isExtended('PROJET')"
                          :showButton="true"
                          :autoSave="true"
                          :readOnly="readOnly"
                          :moduleId="moduleId"
                          :searchText="searchText"
                          :ressourceHeader="ressource"
                          :fiche="fiche"
                          :projet=selectedProjet
                          :route="route"
                          :attribut="attribut"
                          @extended="setExtended"
                          @fullscreen="setFullscreen"
                          @status="updateStatus"
                          @updated="projetUpdated"
                          @selectItem = "selectItem">
          </section-projet>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('VALUATE_META_ATTRIB')">
        <slot name="section-valuate-meta-attrib">
          <section-valuate-meta-attrib ref="VALUATE_META_ATTRIB"
                                       id="VALUATE_META_ATTRIB"
                                       :extended="isExtended('VALUATE_META_ATTRIB')"
                                       :showButton="true"
                                       :autoSave="true"
                                       :readOnly="readOnly"
                                       :moduleId="moduleId"
                                       :searchText="searchText"
                                       :ressourceHeader="ressource"
                                       :fiche="fiche"
                                       :metaAttribs="metaAttrib"
                                       :route="route"
                                       :attribut="attribut"
                                       @extended="setExtended"
                                       @fullscreen="setFullscreen"
                                       @status="updateStatus"
                                       @updated="metaAttribUpdated"
                                       @selectItem = "selectItem">
          </section-valuate-meta-attrib>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CONTRAT_LIST')">
        <slot name="section-contrat-list">
          <section-contrat-list ref="CONTRAT_LIST"
                                id="CONTRAT_LIST"
                                :extended="isExtended('CONTRAT_LIST')"
                                :showButton="true"
                                :autoSave="true"
                                :readOnly="readOnly"
                                :moduleId="moduleId"
                                :searchText="searchText"
                                :ressourceHeader="ressource"
                                :fiche="fiche"
                                :projet=selectedProjet
                                :route="route"
                                :attribut="attribut"
                                @extended="setExtended"
                                @fullscreen="setFullscreen"
                                @status="updateStatus"
                                @toggleCardView="toggleCardView"
                                @updated="contratUpdated"
                                @selectItem = "selectItem">
          </section-contrat-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Projet from '@/extend/classes/Projet';
import MetaAttrib from '@/extend/classes/MetaAttrib';
import { storeMetaAttrib } from '@/generated/stores';
import Contrat from '@/extend/classes/Contrat';
import { storeContrat } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionProjet from '@/extend/sections/SectionProjetExtend.vue';
import SectionValuateMetaAttrib from '@/framework/metaAttrib/components/SectionValuateMetaAttrib.vue';
import SectionContratList from '@/extend/sections/SectionContratListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionProjet,
    SectionValuateMetaAttrib,
    SectionContratList,
    FicheHeader,
  },

  props: {
    projet: {
      type: Object as PropType<Projet>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PROJET,
      sections: [
        'PROJET',
        'VALUATE_META_ATTRIB',
        'CONTRAT_LIST',
      ],

      contrat: new Contrat(),
    }
  },

  computed: {
    metaAttrib() : MetaAttrib[] {
      const res: MetaAttrib[] = [];
      storeMetaAttrib.listMetaAttrib.forEach((metaAttrib) => {
        const clone = MetaAttrib.fromJson(metaAttrib);
        const metaValue = this.projet.metaValues.find(a => a.metaAttributId == metaAttrib.id);
        if (metaValue) {
          clone.value = metaValue.value;
        }
        clone.classeId = this.projet.id;
        res.push(clone);
      })
      return this.filterMetaAttrib(res);
    },

    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PROJET);
    },

    selectedProjet (): Projet {
      return this.projet
    },
  },
  methods: {
    filterMetaAttrib (metaAttrib: MetaAttrib[]): MetaAttrib[] {
      return metaAttrib.filter(a => a.classe == 'PROJET');
    },

    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    projetUpdated (projet: Projet) {
    // To implement
    },

    // eslint-disable-next-line
    metaAttribUpdated (metaAttrib: MetaAttrib) {
    // To implement
    },

    // eslint-disable-next-line
    contratUpdated (contrat: Contrat) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.projet || this.projet.id < 0) && value == 'PROJET') {
        this.setExtended(new Extended('PROJET', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
